<template>
  <div class="middle_container">
    <div
      class="right"
      style="min-width: 100%; display: flex; flex-direction: column; position: relative">
      <!-- 搜索好友消息 -->
      <div class="search_c" v-show="showFilterList">
        <div class="search_c__title flex_center">
          <div class="ml_10 m_color_2">搜索结果（{{ searchAccountFriendsList.length }}）</div>
          <div
            @click.prevent="handleCloseSearchList"
            class="m_color_2 mr_10"
            style="margin-left: auto; cursor: pointer">
            <i class="iconfont icon-close1"></i>
          </div>
          <!-- <a @click.prevent="handleCloseSearchList" class="ml_10 m_color_e1" style="cursor: pointer;">关闭</a> -->
        </div>
        <div class="mt_2 mb_2 ml_5">
          <el-tag
            style="margin-right: 2px"
            type="primary"
            v-for="item in filterRef"
            :key="item.key"
            closable
            @close="handleRemoveFilter(item)">
            {{ item.desc }}
          </el-tag>
        </div>
        <div style="flex: 1; height: 1px; position: relative">
          <RecycleScroller
            ref="searchScroll"
            class="scroller"
            :items="searchAccountFriendsList"
            :item-size="50"
            key-field="cid"
            v-slot="{ item }"
            @scroll-end="handleSearchScrollEnd">
            <div
              class="item"
              @click="handleFriendSelect(item)"
              :class="{ on: item.cid == selectedAccountFriendId }">
              <friendItem :item="item" />
            </div>
          </RecycleScroller>
          <div
            v-if="loadingmore"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 67px;
            ">
            <el-button type="danger" link :loading="loadingmore">loading</el-button>
          </div>
          <div v-if="nomoreData" style="position: absolute; bottom: 0; width: 100%">
            <el-alert type="warning" show-icon style="background-color: rgb(254, 240, 240, 0.5)">
              <template #title>
                <div class="flex_center">没有更多数据了</div>
              </template>
            </el-alert>
          </div>
        </div>
      </div>
      <!-- END 搜索好友消息 -->
      <div class="right_top">
        <div class="ct">
          <div class="t1">
            <el-dropdown @command="handlecCommandChange">
              <span class="el-dropdown-link" style="display: flex; align-items: center">
                <i class="iconfont icon-caidan" style="margin-right: 10px; font-weight: bold"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="{ key: -1, desc: '标记账号消息已读（' }">
                    <i class="iconfont icon-icon_clean" style="margin-right: 10px"></i>
                    标记账号消息已读（{{ chatingAccount.new_msg_count }}）
                  </el-dropdown-item>
                  <div
                    class="m_color_2"
                    style="font-weight: bold; padding: 5px; display: flex; justify-content: center">
                    远程搜索
                  </div>
                  <el-dropdown-item
                    :command="{ key: item.value, desc: item.desc }"
                    v-for="item in smartEnumPlugin.getEnumList('MESSAGE_FILTER_LIST')"
                    :key="item.value">
                    <i class="iconfont" :class="item.iconClass" style="margin-right: 10px"></i>
                    {{ item.desc }}
                    <span v-if="item.value == 1">（{{ chatingAccount.new_msg_count }}）</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <el-input
              v-model="searchKeywords"
              @input="handleSearchInput"
              size="small"
              style="padding: 0"
              placeholder="搜索">
              <template #prefix>
                <i class="iconfont icon-search"></i>
              </template>
            </el-input>
          </div>

          <div class="t2" v-if="accountFriendList?.length > 0">
            <!-- 最新消息的好友 -->
            <div
              class="newest_item"
              v-for="(item, index) in accountFriendList.slice(0, 8)"
              :key="index"
              :class="{ newest_item_on: item.cid === selectedAccountFriendId }"
              @click="handleFriendSelect(item)">
              <div v-if="item.avatar" class="newest_item_i">
                <div class="newest_item_c">
                  <img :src="item.avatar" />
                  <!-- <em  v-if="item.new_msg_count && item.cid != selectedAccountFriendId" class="friend_vui__badge">{{ item.new_msg_count }}</em> -->
                </div>
              </div>
              <div class="newest_item_n">
                {{ item.title }}
              </div>
              <em
                v-if="item.new_msg_count && item.cid != selectedAccountFriendId"
                class="item_vui__badge">
                {{ item.new_msg_count }}
              </em>
            </div>
          </div>
          <div class="slider-demo-block" style="padding: 5px 10px 0 10px">
            <div class="flex_center">
              <span style="color: #9ea0a3">
                已加载好友数:{{ loadAccountFriendCount }}/{{ friendsCount }}
              </span>
              <el-button
                @click="handleLoadMore"
                link
                type="primary"
                size="small"
                style="margin-left: 5px">
                加载更多...
              </el-button>
            </div>
          </div>

          <!-- 本地过滤 -->
          <div
            class="flex_center plr_10 m_desc_color"
            style="background-color: rgba(223, 229, 244, 0.1); box-sizing: border-box">
            <div>
              <el-tooltip effect="dark" placement="top-start">
                <template #content>
                  <div>本地过滤数据（只显示后面点亮选线的数据）,新消息会自动刷新</div>
                </template>
                <i
                  class="iconfont icon-a-guangqi_guolv11x"
                  :class="localFilterRef.length > 0 ? 'check_item_select' : 'check_item_init'"
                  style="cursor: pointer"
                  @click="handleClearLocalFilter"></i>
              </el-tooltip>
            </div>
            <div
              @click="handleChangeLocalFilter(item.value)"
              class="check_item"
              :class="[
                localFilterRef.includes(item.value) ? 'check_item_select' : 'check_item_init',
              ]"
              v-for="item in smartEnumPlugin.getEnumList('MESSAGE_FILTER_LIST')"
              :key="item.value"
              style="margin-left: 10px">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>

      <div style="flex: 1; height: 1px; position: relative">
        <RecycleScroller
          ref="scroll"
          class="scroller"
          :items="accountFriendList"
          :item-size="50"
          key-field="cid"
          v-slot="{ item }"
          @scroll-end="handleScrollEnd">
          <div
            class="item"
            @click="handleFriendSelect(item)"
            @contextmenu.prevent="handleContextMenu($event, item)"
            :class="{ on: item.cid == selectedAccountFriendId }">
            <friendItem :item="item" />
          </div>
        </RecycleScroller>
        <div
          v-if="loadingmore"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 67px;
          ">
          <el-button type="danger" link :loading="loadingmore">loading</el-button>
        </div>
      </div>
    </div>

    <!-- 右键菜单 -->
    <div
      v-show="contextMenuVisible"
      :style="{ top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }"
      class="context-menu">
      <div
        style="
          padding-left: 20px;
          padding-bottom: 5px;
          margin-bottom: 5px;
          border-bottom: 1px solid #d9d9d9;
        ">
        操作账号：
        <span>{{ mentRecordItem.title || "--" }}</span>
      </div>
      <el-menu
        ref="menuRef"
        class="main-menu"
        @select="handleContextMenuSelect"
        background-color="#dbe2ef"
        active-text-color="#3f72af"
        text-color="#3f72af">
        <el-menu-item index="1">拉黑（不再显示该好友）</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  inject,
  computed,
  onMounted,
  ref,
  watch,
  onUnmounted,
  provide,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import {
  notifyAccountMsgReaded,
  getAccountFriendCount,
  blackFriend,
  searchAccountFriend,
} from "@/api/chatapi";
import chatDbCache from "@/idxdb/chat_db_cache";
import friendItem from "./components/friendItem.vue";
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { SELECT_FRIEND_LIMIT } from "@/constants/common-const";
export default {
  components: { friendItem, RecycleScroller },
  setup() {
    const router = useRouter();
    const v3layer = inject("v3layer");
    const momentUtil = inject("momentUtil");

    const bus = inject("$eventBus");
    const wsCmd = inject("wsCmd");
    const eventbusCms = inject("eventbusCms");

    const allFriendsNum = ref(0);
    const getAccountFriendsTimmer = ref(undefined);
    const smartEnumPlugin = inject("smartEnumPlugin");
    //本地数据过滤()//类型：1有未读消息，2没有未读消息，3已开口，4未开口
    const localFilterRef = ref([]);
    //--------- 搜索浮层是否显示------
    const showFilterList = computed(() => {
      return searchKeywords.value || filterRef.value.length > 0;
    });

    const nomoreData = ref(false);
    //加载
    const loadingmore = ref(false);

    //好友列表滚动条---------
    const scroll = ref(undefined);

    //搜索好友滚动条
    const searchScroll = ref(undefined);

    // ------------本地搜索数据---------
    const handleChangeLocalFilter = (type) => {
      let findIdx = localFilterRef.value.findIndex((item) => item == type);
      if (findIdx >= 0) {
        localFilterRef.value.splice(findIdx, 1);
      } else {
        localFilterRef.value.push(type);
      }
    };

    const handleClearLocalFilter = async () => {
      localFilterRef.value = [];
    };

    // ------------ 搜索好友 -----------
    const searchAccountFriendsList = ref([]);
    const searchAccountFriendTimmer = ref(undefined);

    const handleCloseSearchList = async () => {
      searchKeywords.value = "";
      filterRef.value = [];
      searchAccountFriendsList.value = [];
    };
    const handleSearchInput = async () => {
      // console.log(searchKeywords.value)
      if (searchKeywords.value.length < 1) {
        searchAccountFriendsList.value = [];
        return;
      }

      searchAccountFriendTimmer.value = setTimeout(() => {
        handleSearchFilterFriends();
      }, 300);
    };
    // 搜索好友
    const handleSearchFilterFriends = async () => {
      let kw = searchKeywords.value;
      if (!kw && filterRef.value.length == 0) {
        return;
      }
      let searchData = {
        aid: selectedAccountId.value,
        keyword: kw,
        limit: SELECT_FRIEND_LIMIT,
        action_type: filterRef.value.map((item) => item.key).join(","),
      };
      loadingmore.value = true;
      searchAccountFriend(searchData);
    };

    // 搜索好友加载更多
    const handleSearchFilterFriendsLoadMore = async () => {
      let kw = searchKeywords.value;
      if (!kw && filterRef.value.length == 0) {
        return;
      }
      let dataList = searchAccountFriendsList.value || [];
      let min_id = 0;
      if (dataList.length > 0) {
        let len = dataList.length;
        min_id = dataList[len - 1].cid;
      }
      let searchData = {
        aid: selectedAccountId.value,
        log_id: min_id,
        keyword: kw,
        limit: SELECT_FRIEND_LIMIT,
        action_type: filterRef.value.map((item) => item.key).join(","),
      };
      loadingmore.value = true;
      searchAccountFriend(searchData, "loadmore");
    };

    const handleReceiveSearchResult = async (res) => {
      //如果没有更多数据了给出提示
      let { data, pb, type } = res;
      let { aid } = data || {};
      let searchResultList = data.friendlist || [];
      loadingmore.value = false;
      if (aid == selectedAccountId.value) {
        let oldList = searchAccountFriendsList.value || [];
        if (searchResultList.length < SELECT_FRIEND_LIMIT) {
          nomoreData.value = true;
          setTimeout(() => {
            nomoreData.value = false;
          }, 2000);
        }
        if ("loadmore" == pb) {
          //加载更多
          for (let item of searchResultList) {
            let findIdx = oldList.findIndex((_item) => _item.cid == item.cid);
            if (findIdx >= 0) {
              let oitem = oldList[findIdx];
              oitem = Object.assign(oitem, item);
            } else {
              oldList.push(item);
            }
          }
          searchAccountFriendsList.value = oldList || [];
        } else {
          if (type == 3) {
            let oldList = searchAccountFriendsList.value || [];
            for (let item of searchResultList) {
              let findIdx = oldList.findIndex((_item) => _item.cid == item.cid);
              if (findIdx >= 0) {
                let oitem = oldList[findIdx];
                oitem = Object.assign(oitem, item);
              } else {
                oldList.push(item);
              }
            }
            searchAccountFriendsList.value = oldList || [];
          } else {
            searchAccountFriendsList.value = searchResultList || [];
          }
        }
        searchScroll.value?.updateVisibleItems(true);
      }
    };
    // ------------ END 搜索好友 -----------

    //------------- 搜索列表滚动到底部 ------------
    const handleSearchScrollEnd = async (e) => {
      loadingmore.value = true;
      handleSearchFilterFriendsLoadMore();
    };

    //-----------右键菜单---------------
    // 菜单显示状态
    const contextMenuVisible = ref(false);
    // 菜单位置
    const contextMenuTop = ref(0);
    const contextMenuLeft = ref(0);
    const menuRef = ref(null); // 菜单的 DOM 引用（关键）
    const mentRecordItem = ref({});

    /**
     * {key:2,desc:'未读'},
     * {key:3,desc:'已开口'},
     * {key:4,desc:'未开口'}
     */
    const filterRef = ref([]);

    let store = useStore();

    const searchKeywords = ref("");

    //右键菜单
    const handleContextMenu = async (e, item) => {
      e.preventDefault();
      let top = e.clientY;
      // 获取视口尺寸
      const viewportHeight = window.innerHeight;
      // 计算安全位置（预留 5px 边距）
      const safeMargin = 5;
      //元素高度暂时设置100px
      // 获取菜单自身尺寸（需考虑边框和内边距，使用 getBoundingClientRect）
      // const menuRect = menuEl.getBoundingClientRect()
      // const menuWidth = menuRect.width
      // const menuHeight = menuRect.height
      let menuHeight = 100;
      // 垂直方向调整：避免超出底部
      if (top + menuHeight > viewportHeight - safeMargin) {
        top = viewportHeight - menuHeight - safeMargin;
      }

      contextMenuVisible.value = true;
      contextMenuTop.value = top;
      contextMenuLeft.value = e.clientX;
      mentRecordItem.value = item;
      // 点击其他地方隐藏菜单
      document.addEventListener("click", hideContextMenu);
    };

    // 隐藏右键菜单
    const hideContextMenu = (e) => {
      // 获取点击的目标元素
      const target = e.target;

      // 判断目标是否在菜单内部（包括菜单本身及其子元素）
      const isInsideMenu = menuRef.value?.$el?.contains(target);

      // 如果点击的是菜单内部，不隐藏；否则隐藏
      if (!isInsideMenu) {
        contextMenuVisible.value = false;
        document.removeEventListener("click", hideContextMenu);
      }
    };

    const handleContextMenuSelect = async (key) => {
      contextMenuVisible.value = false;
      document.removeEventListener("click", hideContextMenu);
      //1 拉黑好友
      if (key == 1) {
        let fid = mentRecordItem.value.cid;
        let data = { fid };
        blackFriend(data);
      }
    };
    // -------end  右键菜单

    //好友列表下拉刷新
    const handleScrollEnd = async () => {
      handleLoadMore();
    };

    //加载更多好友
    const handleLoadMore = async () => {
      loadingmore.value = true;
      setTimeout(() => {
        loadingmore.value = false;
      }, 500);
      let friendList = store.state.chat_store.user_account_friends || [];

      let len = friendList.length;
      //最后一条的好友ID
      let log_id = 0;
      if (len > 0) {
        log_id = friendList[len - 1].cid;
      }
      //发送消息加载账号更多好友
      let data = { aid: selectedAccountId.value, log_id };
      bus.emit(eventbusCms.loadMoreAccountFriend, data);
    };

    //切换好友Ai接管状态
    const handleUseRobotStatusChange = () => {};

    //好友人工接管提示信息
    const handleGetArtificialTipMsg = (item) => {
      let msg = "";

      let AiMsg = "Ai消息(如果AI启用)，";
      //后台AI接管开启
      // if(chatingAccount.value.use_robot_status === 1){
      //   AiMsg = ""
      // }

      //人工接管开启
      if (item.is_artificial == 1) {
        msg = `人工接管状态【开启】：${AiMsg}追粉消息和欢迎语【不会发送】`;
      } else {
        msg = `人工接管状态【关闭】：${AiMsg}追粉消息和欢迎语【正常发送】`;
      }
      return msg;
    };

    //当前选中平台
    // const chatingPlatId = computed(() => {
    //       return store.state.wsData.chatingPlatId
    // });
    //好友个数
    const friendsCount = computed(() => {
      return store.state.chat_store.accountFriendCount[selectedAccountId.value] || 0;
    });

    //当前聊天账号
    const chatingAccount = computed(() => {
      return store.state.chat_store.user_account_select;
    });

    //当前选中账号
    const selectedAccountId = computed(() => {
      return store.state.chat_store.user_account_select?.id;
    });

    //当前选中好友
    const selectedAccountFriendId = computed(() => {
      return store.state.chat_store.user_account_select_friend?.cid;
    });
    provide("selectedAccountFriendId", selectedAccountFriendId);

    // const platAccountActiveMap = computed(()=>{
    //   return    store.state.wsData.platAccountActiveMap
    // })

    //加载的好友个数
    const loadAccountFriendCount = computed(() => {
      let friendList = store.state.chat_store.user_account_friends;
      return friendList?.length || 0;
    });

    //------------正常账号列表------
    const friendLists = ref([]);
    //账号列表
    const accountFriendList = computed(() => {
      //localFilterRef
      let _friendList = friendLists.value;
      //过滤条件
      if (localFilterRef.value.length > 0) {
        _friendList = _friendList.filter((item) => {
          if (item.cid == selectedAccountFriendId.value) {
            return true;
          }
          for (let v of localFilterRef.value) {
            let res = false;
            //未读--
            if (v == 1) {
              res = item.new_msg_count > 0;
              if (!res) {
                return false;
              }
            }
            //已开口--
            if (v == 3) {
              res = item.is_interact == 1 ? true : false;
              if (!res) {
                return false;
              }
            }

            //线索
            if (v == 11) {
              res = item.save_customer_flg == 1 ? true : false;
              if (!res) {
                return false;
              }
            }
            //未回
            if (v == 5) {
              res = item.employee_not_reply_flg == 1 ? true : false;
              if (!res) {
                return false;
              }
            }
            //复制名片
            if (v == 21) {
              res = item.is_copy_contact == 1 ? true : false;
              if (!res) {
                return false;
              }
            }
          }
          return true;
        });
      }

      //按照最新发送时间排序
      _friendList = _friendList.sort((item1, item2) => {
        if (!item1.time && !item2.time) {
          return 0;
        }

        if (!item2.time) {
          return -1;
        }

        if (!item1.time) {
          return 1;
        }

        let item1Time = momentUtil.moment(item1.time, "YYYY-MM-DD HH:mm:ss");
        let item2Time = momentUtil.moment(item2.time, "YYYY-MM-DD HH:mm:ss");

        if (item1Time.isAfter(item2Time)) {
          return -1;
        } else if (item2Time.isAfter(item1Time)) {
          return 1;
        } else {
          return 0;
        }
      });

      return _friendList;
    });

    //过滤好友
    const haldleFilterFriend = (friendItem, searchKeyWords) => {
      if (searchKeyWords) {
        let _searchKeywords = searchKeyWords.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
        if (_searchKeywords.length == 0) {
          return true;
        }
        let title = friendItem.title;
        if (!title) {
          return false;
        }
        return title.includes(_searchKeywords);
      } else {
        return true;
      }
    };

    //好友右键菜单
    const handleContextLayer = (e) => {
      e.preventDefault();
      let pos = [e.clientX, e.clientY];
      let $el = v3layer({
        type: "contextmenu",
        opacity: 0,
        follow: pos,
        btns: [
          { text: "置顶" },
          { text: "标为已读" },
          { text: "开启新消息提醒" },
          { text: "设置备注" },
          {
            text: "删除",
            click: () => {
              $el.close();
            },
          },
        ],
      });
    };

    const handleFriendSelect = (item) => {
      //新缓存
      store.dispatch("chat_store/doUserAccountFriendSelect", item);
      item.new_msg_count = 0;
    };
    const handleGoUrl = (item) => {
      // store.commit("wsData/SET_CHATING_FRIEND", item);
      //因为是多账号，这里需要记住哪个账号激活的是哪个好友聊天
      router.push({ name: "groupChat", query: { id: item.cid } });
      bus.emit(eventbusCms.selectFriendChange, item.cid);
    };

    const handleDateTimeFormat = (dateStr) => {
      if (!dateStr) {
        return "";
      }
      let timeMoment = momentUtil.moment(dateStr, "YYYY-MM-DD HH:mm:ss");
      if (timeMoment.isSame(momentUtil.moment(), "day")) {
        return timeMoment.format("HH:mm");
      }
      return timeMoment.fromNow();
    };
    //当前聊天好友
    const chatingFriendInfo = computed(() => {
      return store.state.chat_store.user_account_select_friend;
    });

    //标记账号消息已读
    const handleNotifyAccountMsgReaded = () => {
      notifyAccountMsgReaded({ aid: selectedAccountId.value });
      for (let i = 0; i < accountFriendList.value.length; i++) {
        // console.log(accountFriendList.value[i].new_msg_count)
        accountFriendList.value[i].new_msg_count = 0;
      }

      //本地清空
      ElMessage({
        showClose: true,
        message: "操作成功",
        type: "success",
      });
    };

    // 过滤条件变更---------------------------
    const handlecCommandChange = (cmd) => {
      switch (cmd.key) {
        case -1:
          handleNotifyAccountMsgReaded();
          return;
        default:
          if (!filterRef.value.some((item) => item.key == cmd.key)) {
            filterRef.value.splice(0, filterRef.value.length, cmd);
            handleSearchFilterFriends();
          }
          return;
      }
    };
    // 移除过滤条件------------------------
    const handleRemoveFilter = (item) => {
      let findIdx = filterRef.value.map((item) => item.key).indexOf(item.key);
      if (findIdx != -1) {
        filterRef.value.splice(findIdx, 1);
        handleSearchFilterFriends();
      }
    };

    const handleSpeakStr = (is_interact) => {
      return is_interact == 1 ? "已开口" : "未开口";
    };
    const handleGetAccontFriendCount = async (account_id) => {
      if (!account_id) {
        return;
      }

      //立即执行一次
      let data = { aid: account_id };
      getAccountFriendCount(data);
      handleGetAccontFriendCount0(data);
    };

    const handleGetAccontFriendCount0 = async (data) => {
      if (getAccountFriendsTimmer.value) {
        clearTimeout(getAccountFriendsTimmer.value);
        getAccountFriendsTimmer.value = undefined;
      }
      //定时查询
      getAccountFriendsTimmer.value = setTimeout(() => {
        getAccountFriendCount(data);
        handleGetAccontFriendCount0(data);
      }, 10000);
    };

    onMounted(() => {
      //当前选中好友
      // handleGoUrl(chatingFriendInfo.value)
      bus.on(`${wsCmd.cmd_31_resp}`, handleReceiveSearchResult); // listen
      bus.on(`${wsCmd.cmd_3_resp}`, handleReceiveSearchResult); // listen
    });

    onUnmounted(() => {
      if (getAccountFriendsTimmer.value) {
        clearTimeout(getAccountFriendsTimmer.value);
        getAccountFriendsTimmer.value = undefined;
      }
      bus.off(`${wsCmd.cmd_3_resp}`, handleReceiveSearchResult); // listen
    });

    //---------监听器--------------------
    // 单个 ref
    watch(selectedAccountId, () => {
      handleGetAccontFriendCount(selectedAccountId.value);
      if (showFilterList.value) {
        //切换账号时查询条件不变更，重新重新搜索好友
        handleSearchFilterFriends();
      }
    });

    watch(
      () => selectedAccountFriendId.value,
      (newValue, oldValue) => {
        // console.log('================change ===============', newValue, oldValue)
        //获取账号选中好友
        if (selectedAccountFriendId.value) {
          handleGoUrl(chatingFriendInfo.value);
        }
      },
    );

    watch(
      () => store.state.chat_store.user_account_friends,
      (newValue) => {
        loadingmore.value = false;
        friendLists.value = newValue;
        scroll.value?.updateVisibleItems(true);
      },
      { deep: true },
    );
    return {
      accountFriendList,
      selectedAccountFriendId,
      selectedAccountId,
      chatingFriendInfo,
      allFriendsNum,
      chatingAccount,
      filterRef,
      contextMenuVisible,
      contextMenuTop,
      contextMenuLeft,
      menuRef,
      mentRecordItem,
      //------------
      haldleFilterFriend,
      handleContextLayer,
      handleGoUrl,
      handleDateTimeFormat,
      handleNotifyAccountMsgReaded,
      handleSpeakStr,
      handlecCommandChange,
      handleRemoveFilter,
      handleUseRobotStatusChange,
      handleGetArtificialTipMsg,
      handleLoadMore,
      handleFriendSelect,
      handleContextMenu,
      friendsCount,
      loadAccountFriendCount,
      handleContextMenuSelect,
      handleCloseSearchList,
      searchAccountFriendsList,
      handleSearchInput,
      handleScrollEnd,
      handleSearchScrollEnd,
      scroll,
      searchScroll,
      loadingmore,
      showFilterList,
      searchKeywords,
      nomoreData,
      smartEnumPlugin,
      localFilterRef,
      handleChangeLocalFilter,
      handleClearLocalFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  height: 100%;
}

::v-deep(.el-input__inner) {
  height: 25px;
  // background-color: red;
  border: none;
  background-color: rgba(255, 255, 255, 0.9);
}

.right_top_tip {
  padding-left: 10px;
  width: 100%;
  box-sizing: border-box;
  height: 15px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  color: #9ea0a3;
  font-size: 10px;
  position: absolute;
  bottom: 0;

  .right_top_tip_n {
    //
    color: rgb(0, 139, 139);
  }

  .right_top_tip_go {
    padding-right: 5px;
    margin-left: auto;
    color: rgba(64, 158, 255, 1);
  }

  .right_top_tip_go1 {
    padding-right: 5px;
    margin-left: auto;
  }

  .right_top_tip_go:hover {
    cursor: pointer;
  }
}

.right_top {
  min-height: 55px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px;

  // .right_top_util{
  //    height: 30px;
  // }
  .ct {
    min-width: 270px;
    flex: 1;

    .t1 {
      box-sizing: border-box;
      display: flex;
      padding-right: 5px;
      padding-left: 5px;
      height: 30px;
    }

    .t2 {
      display: flex;
      height: 50px;
      align-items: center;
      box-sizing: border-box;
      margin-top: 5px;
      overflow: hidden;
      position: relative;

      .newest_item_on {
        /* background-color: #dedede */
        background-color: rgba(223, 229, 244, 0.9);
      }

      .newest_item {
        padding-top: 2px;
        cursor: pointer;
        width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-right: 2px;
        border-radius: 5px;

        .newest_item_n {
          margin-top: 2px;

          width: 40px;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          white-space: nowrap;
          font-size: 10px;
          color: #9ea0a3;
        }

        .newest_item_i {
          width: 30px;
          height: 30px;
          border-radius: 100%;
          overflow: hidden;
          position: relative;
          flex-shrink: 0;
          flex-grow: 0;

          .newest_item_c img {
            width: 30px;
            height: 30px;
          }
        }

        .item_vui__badge {
          position: absolute;
          top: 0px;
          right: 0px;
        }
      }

      .newest_item:hover {
        background-color: #e2e2e2;
      }
    }
  }

  .right_top_input {
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .right_top_util {
    box-sizing: border-box;
    padding-right: 10px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .util_item {
      cursor: pointer;
    }

    // .util_item:hover{
    //   background-color: rgba(0, 0, 0, 0.5);
    // }
  }
}

.friend_item {
  box-sizing: border-box;

  .r1 {
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
    display: flex;

    .r1_l {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      // width: 140px;
      box-sizing: border-box;
    }

    .r1_r {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      width: 60px;
      text-align: right;
    }
  }

  .r2 {
    margin-top: 5px;
    white-space: nowrap;
    box-sizing: border-box;

    p {
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;

      .speack_icon {
        color: rgb(0, 139, 139);
      }

      .nospeack_icon {
        color: #9ea0a3;
      }
    }
  }
}

.middle_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 10px;
}

.friend_img_container {
  box-sizing: border-box;
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;
  // animation-name: shake;
  // animation-duration: 5ms;
  // animation-iteration-count: infinite;
  // animation-timing-function: ease-in-out;
}

// @keyframes shake {

//   0%,
//   100% {
//     transform: translate(0) rotate(0deg) scale(.9);
//   }

//   10%,
//   30%,
//   50%,
//   70%,
//   90% {
//     transform: translate(2px,-2px) rotate(-0.5deg) scale(1.1);
//   }

//   20%,
//   40%,
//   60%,
//   80% {
//     transform: translate(-2px,2px) rotate(0.5deg) scale(1);
//   }
// }

.friend_vui__badge {
  position: absolute;
  top: 0px;
  right: 0px;
}

// -------右键菜单--------
.context-menu {
  position: fixed;
  z-index: 9999;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 150px;
  border: 1px solid #3f72af;
  box-sizing: border-box;
  background-color: #dbe2ef;
  padding: 10px;
  border-radius: 0 0 0 20px;
}

.main-menu {
  --el-menu-item-height: 25px;
  --el-menu-sub-item-height: calc(var(--el-menu-item-height) - 3px);
}

// ----------------- 搜索好友 ----------------
.search_c {
  position: absolute;
  top: 40px;
  z-index: 999;
  box-sizing: border-box;
  border-radius: 15px 15px 10px 10px;
  // background-color: rgba(24, 24, 24, .9);
  background-color: rgba(255, 255, 255, 0.9);
  width: 100%;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
}

.search_c__title {
  // background-color: rgba(24, 24, 24, 1);
  background-color: rgba(223, 229, 244, 0.9);
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  box-shadow: 0px 10px 10px 0px rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 10px 10px 0 0;
}

// ------ 滚动条 -----
.item {
  font-family: "Microsoft Yahei";
  display: flex;
  align-items: center;
  position: relative;
  height: 48px;
  overflow: hidden;
  min-width: 270px;
  overflow: hidden;
  border-radius: 5px;
  padding: 2px 5px;
  margin: 1px 5px;
  cursor: pointer;
  background-color: rgba(223, 229, 244, 0.1);
}

.item:hover {
  background-color: #e2e2e2;
}

.item.on {
  /* background-color: #dedede */
  background-color: rgba(223, 229, 244, 0.9);
}

::-webkit-scrollbar {
  height: 3px;
  width: 5px;
  display: block;
}

::-webkit-scrollbar-track {
  background-color: #f3f3f3;
}

::-webkit-scrollbar-track-piece {
  background: #f3f3f3;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  min-height: 15px;
  width: 3px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4);
}

::-webkit-scrollbar-thumb:active {
  background: rgba(0, 0, 0, 0.5);
}

// ----------------- END 搜索好友 ----------------
</style>
